/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import OrgAppUserCreationBtn from '../views/organization/application/users/OrgAppUserCreationBtn';
import { useDispatch } from 'react-redux';
import Loader from '../../../../../components/ui-elements/loader';
import { useParams } from 'react-router-dom';
import OrgAppsUsers from '../views/organization/application/users/OrgAppsUsers';
import { getAllOrgsAppsUsersByOrgID } from '../../../../../store/reducers/applicationUsers/applicationUsersAction';

const ManageOrganizationApplicationUsersPage = () => {
    const [loading, setLoading] = useState(false);
    const { orgappid } = useParams();
    const dispatch = useDispatch()

    const fetchORgAppsUsers = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrgsAppsUsersByOrgID({ 'organizationApplicationID': orgappid })).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }

    }, [dispatch, orgappid])
    useEffect(() => {
        fetchORgAppsUsers()
    }, [fetchORgAppsUsers]);
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Organization Applications Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <OrgAppUserCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {!loading ? <OrgAppsUsers /> : (<Loader />)}
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}


export default ManageOrganizationApplicationUsersPage; 